import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useState, useMemo, useCallback } from 'react';
import useForkRef from './use-fork-ref.esm.js';

function useToggle() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var reverseValue = arguments.length > 1 ? arguments[1] : undefined;
  var refState = arguments.length > 2 ? arguments[2] : undefined;
  var internalRef = useRef();
  var _refState = useForkRef(internalRef, refState);
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var reverseValueOrigin = useMemo(function () {
    return reverseValue === undefined ? !defaultValue : reverseValue;
  }, [defaultValue, reverseValue]);

  // Toggle return value
  var toggle = useCallback(function (value) {
    // Force return status value, suitable for click operation
    if (value !== undefined) {
      // eslint-disable-next-line no-console
      // console.log(`----useToggle toggle setState value: ${value}-----`)
      setState(value);
      typeof _refState === 'function' && _refState(value);
      return;
    }
    setState(function (state) {
      var newState = state === defaultValue ? reverseValueOrigin : defaultValue;
      // eslint-disable-next-line no-console
      // console.log(`----useToggle toggle setState newState: ${newState}-----`)
      typeof _refState === 'function' && _refState(newState);
      return newState;
    });
  }, [_refState, defaultValue, reverseValueOrigin]);

  // set default value
  var setLeft = useCallback(function () {
    // eslint-disable-next-line no-console
    // console.log(`----useToggle setLeft/on setState ${defaultValue}-----`)
    setState(defaultValue);
    typeof _refState === 'function' && _refState(defaultValue);
  }, [_refState, defaultValue]);

  // Set the negation value
  var setRight = useCallback(function () {
    // eslint-disable-next-line no-console
    // console.log(
    //   `----useToggle setRight/off setState ${reverseValueOrigin}-----`
    // )
    setState(reverseValueOrigin);
    typeof _refState === 'function' && _refState(reverseValueOrigin);
  }, [_refState, reverseValueOrigin]);
  return {
    state: state,
    toggle: toggle,
    setLeft: setLeft,
    setRight: setRight,
    refState: refState ? refState : internalRef
  };
}

export default useToggle;
//# sourceMappingURL=use-toggle.esm.js.map
